import {useMutation, useQueryClient} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {useModal} from "../../../../../hooks";
import {OrdersShipmentDeliveryConfirmType} from "../interface";
import {updateShipmentDeliveryConfirm} from "../../../../../api/order/OrdersApi";

export const useUpdateShipmentDeliveryConfirm = () => {
    const {handleModal} = useModal();
    const qc = useQueryClient()

    const {mutate, mutateAsync} = useMutation({
        mutationFn: (data: OrdersShipmentDeliveryConfirmType) => updateShipmentDeliveryConfirm(data),
        onSuccess: () => {
            handleModal({
                isOpen: true,
                contents: "수정되었습니다.",
                type: "alert",
                closeAction: () => {
                    qc.invalidateQueries({queryKey: ["readShipmentDeliveryConfirm"]})
                }
            });
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate, mutateAsync};
};
